// extracted by mini-css-extract-plugin
export default {"navItem":"nav-items_navItem__KRrXY","navActive":"nav-items_navActive__+vERY","navInactive":"nav-items_navInactive__-aarV"};